<template>
  <div>
    <v-dialog ref="dialog_datepicker" no-click-animation v-model="datepicker" transition="slide-y-transition" persistent lazy full-width width="290px">
      <v-date-picker v-model="selectedDate" :min="minimumDate" :max="maximumDate" scrollable>
        <v-spacer></v-spacer>
        <v-btn text color="primary" @click="$parent.fn_closeDialog">Cancel</v-btn>
        <v-btn text color="primary" @click="fn_saveDate(selectedDate)">OK</v-btn>
      </v-date-picker>
    </v-dialog>
  </div>
</template>

<script>
let currentDateObj = new Date();

export default{
  props:['selected', 'minimumDate', 'maximumDate', 'updateDate'],
  data(){
    return{
      datepicker: false,
      selectedDate:currentDateObj.getFullYear()+'-'+("0" + (currentDateObj.getMonth()+1)).slice(-2)+'-'+("0" + currentDateObj.getDate()).slice(-2)
    }
  },
  methods:{
    openDialogWeb: function () {
      let dateObj = this.selected ? new Date(this.selected) : new Date();
      this.selectedDate = dateObj.getFullYear()+'-'+("0" + (dateObj.getMonth()+1)).slice(-2)+'-'+("0" + dateObj.getDate()).slice(-2);
      this.datepicker = true;
    },
    closeDialogWeb: function () {
      this.datepicker = false;
    },
    fn_saveDate: function (value) {
      let dateObj = new Date(value);
      this.$refs.dialog_datepicker.save(value);
      this.updateDate(dateObj);
    }
  }
}
</script>